import { render, staticRenderFns } from "./scripts-configuration.component.vue?vue&type=template&id=4911dc14&scoped=true&"
import script from "./scripts-configuration.component.vue?vue&type=script&lang=ts&"
export * from "./scripts-configuration.component.vue?vue&type=script&lang=ts&"
import style0 from "./scripts-configuration.component.vue?vue&type=style&index=0&id=4911dc14&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4911dc14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VFadeTransition,VForm})
